module.exports = __webpack_public_path__ + "img/dsci0012.29456fd2.jpg";